const ADJUSTMENT_TYPES = {
  TIP: 'TIP',
  SERVICE: 'SERVICE'
}

export {
  ADJUSTMENT_TYPES
}